import { ReactNode } from "react";
import { Typography } from "@mui/material";
import LeftGraphic from "../../../images/video-left-graphic.svg";
import TopRightGraphic from "../../../images/video-top-right-graphic.svg";
import BottomRightGraphic from "../../../images/video-bottom-right-graphic.svg";
import styles from "./index.module.css";

type VideoPageProps = {
	src: string;
	videoTitle?: string;
	header?: ReactNode;
	description?: ReactNode;
	bottomContent?: ReactNode;
};

export default function VideoPage({ src, videoTitle, header, description, bottomContent }: VideoPageProps) {
	return (
		<div className={styles.backgroundContainer}>
			<div className={styles.pageContainer}>
				<div className={styles.contentContainer}>
					<div className={styles.videoContainer}>
						<img className={styles.leftGraphic} src={LeftGraphic} alt="" role="presentation" />
						<img className={styles.topRightGraphic} src={TopRightGraphic} alt="" role="presentation" />
						<img className={styles.bottomRightGraphic} src={BottomRightGraphic} alt="" role="presentation" />
						<iframe src={src} title={videoTitle} className={styles.video} allowFullScreen loading="lazy" />
					</div>
					{(header || description) && (
						<div className={styles.textContainer}>
							{header && (
								<Typography component="h2" fontSize="20px" fontWeight="600">
									{header}
								</Typography>
							)}
							{description && (
								<Typography fontSize="15px" fontWeight="400">
									{description}
								</Typography>
							)}
						</div>
					)}
					{bottomContent}
				</div>
			</div>
		</div>
	);
}
